'use client';

// TODO: remove alternate UI and zomato things

import { LogoStrokedGradient } from 'assets/icons';
import { Container } from '..';
import Image from 'next/image';
import CustomLink from 'components/shared/CustomLink';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import styles from './InviteHero.module.css';

const data = [
  {
    image:
      'https://public-web-assets.ultrahuman.com/web_v2/illustrations/zomatoA.svg',
    numbers: '50,00,000',
    message: `Kms covered by Zomato's delivery boys per day`,
  },
  {
    image:
      'https://public-web-assets.ultrahuman.com/web_v2/illustrations/zomatoB.svg',
    numbers: '$887 million',
    message: `Annual Revenue, is larger than GDP of 70 countries`,
  },
];

export const InviteHero = ({
  className,
  name,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  banner,
  code,
  subtitle,
  alternateUI = false,
}: {
  className?: string;
  name: string;
  banner?: string | undefined | null;
  code?: string;
  subtitle?: string;
  alternateUI?: boolean;
}) => {
  const searchParams = useSearchParams();
  const routerQuery = useMemo(() => {
    const query: Record<string, string | string[]> = {};
    if (!searchParams) return query;
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      query[key] = values.length > 1 ? values : values[0];
    }
    return query;
  }, [searchParams]);

  return (
    <section
      className={`${styles.root} ${
        alternateUI ? styles.alternateUI : styles.normalUI
      }${className ? ` ${className}` : ''}`}
    >
      {alternateUI && (
        <>
          <div className={styles['alternate-ui']} />
          <div className={styles['alternate-ui-gradient']} />
        </>
      )}

      <div className={styles['noise-bg']} aria-hidden="true"></div>
      <Container className={styles.content}>
        {alternateUI && (
          <div className={styles['org-collab-tag']}>
            <span className={styles.logo}>
              <Image
                fill
                src={
                  'https://public-web-assets.ultrahuman.com/web_v2/illustrations/uhLogo.svg'
                }
                alt="uh_logo"
              />{' '}
            </span>
            {name ? (
              <>
                {' '}
                for{' '}
                <span className={`${styles.logo} ${styles.zomato}`}>
                  <Image
                    fill
                    src={
                      'https://public-web-assets.ultrahuman.com/web_v2/illustrations/zomatoLogo.svg'
                    }
                    alt="zomato_logo"
                  />
                </span>
              </>
            ) : null}{' '}
          </div>
        )}

        {!alternateUI && <LogoStrokedGradient className-="uh-logo" />}
        {!alternateUI ? (
          <h1>
            You are invited
            {name ? (
              <>
                {' '}
                by
                <br />
                {name}
              </>
            ) : null}
          </h1>
        ) : (
          <h1 className={styles['corporate-head']}>Better food for more people</h1>
        )}

        <p className={alternateUI ? styles['corporate-subtitle'] : ''}>
          {subtitle
            ? subtitle
            : "Explore Ultrahuman and get exclusive offers using the affiliate's coupon code"}
        </p>

        {alternateUI && (
          <>
            <CustomLink
              href={{
                pathname: 'ring/buy',
                query: {
                  ...routerQuery,
                  affiliateCode: code,
                },
              }}
            >
              <p className={styles['id-text']}>Access Zomato only pricing</p>{' '}
            </CustomLink>
            <hr className={styles.separator} />

            <div className={styles['corporate-metrics']}>
              {data.map((e, i) => {
                return (
                  <div key={i} className={styles['corporate-element']}>
                    <div className={styles['media-image']}>
                      <Image fill src={e.image} alt={e.message} />
                    </div>
                    <h3>{e.numbers}</h3>
                    <p>{e.message}</p>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </Container>
    </section>
  );
};
